import React from "react";
import { toast } from "react-toastify";
import FormattedNumber from "@/shared/components/FormattedNumber";
import {
  ActivityContainer,
  ActivityHeader,
  ActivityTitle,
  BackButton,
  TableWrap,
  SmallTable,
  SmallTh,
  SmallTd,
  BadgeDir,
  HashContainer,
  HashLink,
  CopyButton,
  HashText,
  DescText,
  EmptyStateTd,
} from "./styledComponents";
import { getBSCTxUrl } from "../../../../utils/blockchainExplorer";

function ActivityView({ wallet, activity, movements, isLoadingActivities, onBack }) {
  console.log("🚀 ~ ActivityView ~ movements:", movements)
  const formatHash = (hash) => {
    if (!hash || hash === "-") return "-";
    if (hash.length <= 5) return hash;
    return `${hash.substring(0, 3)}...${hash.substring(hash.length - 2)}`;
  };

  const handleCopyHash = (e, hash) => {
    e.stopPropagation();
    if (hash && hash !== "-") {
      navigator.clipboard?.writeText(hash);
      toast.success("Hash copied to clipboard");
    }
  };

  const handleHashClick = (e, hash) => {
    e.stopPropagation();
    if (hash && hash !== "-") {
      window.open(getBSCTxUrl(hash), "_blank", "noopener,noreferrer");
    }
  };

  return (
    <ActivityContainer>
      <ActivityHeader gap={8}>
        <ActivityTitle>
          Activity · {wallet} · {activity.symbol}
        </ActivityTitle>
        <BackButton onClick={() => onBack && onBack(wallet)}>Back to chart</BackButton>
      </ActivityHeader>
      <TableWrap>
        <SmallTable>
          <thead>
            <tr>
              <SmallTh>Name</SmallTh>
              <SmallTh>Direction</SmallTh>
              <SmallTh>Wallet</SmallTh>
              <SmallTh>Amount</SmallTh>
              <SmallTh>Hash</SmallTh>
              <SmallTh>Fee</SmallTh>
              <SmallTh>Date/Time</SmallTh>
            </tr>
          </thead>
          <tbody>
            {isLoadingActivities ? (
              <tr>
                <EmptyStateTd colSpan={6}>
                  Loading activities...
                </EmptyStateTd>
              </tr>
            ) : movements && movements.length > 0 ? (
              movements
                .filter((m) => m.wallet === wallet && m.symbol === activity.symbol)
                .map((m, idx) => {
                  const hash = m.hash || m.ref;
                  const hasHash = hash && hash !== "-";
                  return (
                    <tr key={`${wallet}-${activity.symbol}-movement-${idx}`}>
                      <SmallTd>
                        <DescText>{m.desc || "-"}</DescText>
                      </SmallTd>
                      <SmallTd>
                        <BadgeDir direction={m.direction}>{m.direction === "in" ? "Incoming" : "Outgoing"}</BadgeDir>
                      </SmallTd>
                      <SmallTd>{m.wallet}</SmallTd>
                      <SmallTd>
                        <FormattedNumber value={m.amount || 0} maxDecimals={8} />
                      </SmallTd>
                      <SmallTd>
                        {hasHash ? (
                          <HashContainer>
                            <HashLink onClick={(e) => handleHashClick(e, hash)}>
                              {formatHash(hash)}
                            </HashLink>
                            <CopyButton onClick={(e) => handleCopyHash(e, hash)}>
                              Copy
                            </CopyButton>
                          </HashContainer>
                        ) : (
                          <HashText>-</HashText>
                        )}
                      </SmallTd>
                      <SmallTd>{m.fee || "-"}</SmallTd>
                      <SmallTd>{m.ts}</SmallTd>
                    </tr>
                  );
                })
            ) : (
              <tr>
                <EmptyStateTd colSpan={6}>
                  No activities available for {activity.symbol}
                </EmptyStateTd>
              </tr>
            )}
          </tbody>
        </SmallTable>
      </TableWrap>
    </ActivityContainer>
  );
}

export default ActivityView;

